"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _TransitionablePortal = _interopRequireDefault(require("./TransitionablePortal"));

exports.default = _TransitionablePortal.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/TransitionablePortal/index.js
// module id = 1448
// module chunks = 0